import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { GetUsersPaginatedModel } from '../../../models/apis/system/user/get-users-paginated.model';
import { BaseMapperWithSerializer } from '../../base.mapper';
import { UserQueryModel } from '../../../models/apis/system/user/user-query.model';
import { UserQueryHttp } from '../../../http-models/systems/user/user-query.http';
import { UserItemListModel } from '../../../models/apis/system/user/user-item-list.model';

@Injectable({
    providedIn: 'root',
})
export class GetUsersPaginatedMapper
    implements
    BaseMapperWithSerializer<
            GetUsersPaginatedModel,
            string,
            DataResponseModel<UserQueryModel>,
            DataResponseHttp<UserQueryHttp>
        >
{
    convertTo(model: GetUsersPaginatedModel): string {
        let request = `?PageIndex=${model.pageIndex}&PageSize=${model.pageSize}`;
        if(model.filter){
            request += `&Filter=${model.filter}`;
        }
        if(model.hospitalIds && model.hospitalIds.length>0){
            model.hospitalIds.forEach(value => {
                request += `&HospitalIds=${value}`;
            });
        }
        if(model.departmentIds && model.departmentIds.length>0){
            model.departmentIds.forEach(value => {
                request += `&DepartmentIds=${value}`;
            });
        }
        if(model.roleIds && model.roleIds.length>0){
            model.roleIds.forEach(value => {
                request += `&RoleIds=${value}`;
            });
        }
        if(model.sortBy){
            request += `&SortBy=${model.sortBy}`;
        }
        if(model.sortOrder != null || model.sortOrder != undefined){
            request += `&SortOrder=${model.sortOrder}`;
        }
        request += `&IsActive=${model.isActive}`;
        return request;
    }

    convertFrom(
        http: DataResponseHttp<UserQueryHttp>
    ): DataResponseModel<UserQueryModel> {

        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<UserQueryModel>;
        if(http.isError!=true && http.data){

            response.data = {
                pageIndex: http.data.pageIndex,
                pageSize: http.data.pageSize,
                totalPages: http.data.totalPages,
                totalRecords: http.data.totalRecords,
                isNextPageAvailable: http.data.isNextPageAvailable,
                sortBy: http.data.sortBy,
                sortOrder: http.data.sortOrder,
                isActive: http.data.isActive,
                hospitalIds: http.data.hospitalIds ?? [],
                departmentIds: http.data.departmentIds ?? [],
                roleIds: http.data.roleIds ?? [],
                users: []
            } as UserQueryModel;

            for(let itemHttp of http.data.users){
              let itemModel = {} as UserItemListModel;
              itemModel.id = itemHttp.id;
              itemModel.email = itemHttp.email;
              itemModel.firstName = itemHttp.firstName;
              itemModel.lastName = itemHttp.lastName ?? '';
              itemModel.lastLoginTime = itemHttp.lastLoginTime ? new Date(itemHttp.lastLoginTime) : null;
              itemModel.isAdminUser = itemHttp.isAdminUser;
              itemModel.createdBy = itemHttp.createdBy;
              itemModel.createdDateUtc = new Date(itemHttp.createdDateUtc);
              itemModel.updatedBy = itemHttp.updatedBy;
              itemModel.updatedDateUtc = new Date(itemHttp.updatedDateUtc);
              itemModel.isActive = itemHttp.isActive;

              if(itemHttp.hospitals && itemHttp.hospitals.length>0){
                itemModel.hospitals = itemHttp.hospitals.join(', ')||'';
              }

              if(itemHttp.departments && itemHttp.departments.length>0){
                itemModel.departments = itemHttp.departments.join(', ') || '';
              }

              if(itemHttp.roles && itemHttp.roles.length>0){
                itemModel.roles = itemHttp.roles.join(', ') || '';
              }

              response.data.users.push(itemModel);
            }
        }
        return response;
    }
}
